'use client';
import { memo } from 'react';
import { Box } from '@chakra-ui/react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Mousewheel, Grid, Autoplay, Navigation, Controller } from 'swiper/modules';

import { breakpoints } from 'app/themeConfig';

import 'swiper/scss';
import 'swiper/scss/free-mode';
import 'swiper/scss/pagination';
import './model/sliderStyles.scss';

const Slider = ({
  controller,
  setController,
  slidesData,
  SlideComponent,
  slideComponentProps = null,
  slideStyle = null,
  sameStyles = null,
  useBreakpoints = true,
  containerProps = null,
  ...swiperProps
}) => (
  <Box w="full" className="box-swiper" {...containerProps}>
    <Swiper
      spaceBetween="20px"
      slidesPerView={1}
      grabCursor={true}
      freeMode={true}
      touchReleaseOnEdges
      controller={{ control: controller }}
      pagination={{ clickable: true }}
      breakpoints={
        useBreakpoints && {
          [parseInt(breakpoints.tablet)]: { slidesPerView: 'auto' },
        }
      }
      modules={[Grid, Autoplay, Pagination, Mousewheel, Navigation, Controller]}
      {...swiperProps}
      onSwiper={swiper => setController && setController(swiper)}
    >
      {slidesData?.map((val, index) => {
        let style;
        if (typeof slideStyle === 'function') {
          style = slideStyle(index);
        } else if (typeof slideStyle === 'object') {
          style = slideStyle?.[index];
        }
        const slideComponentData = Array.isArray(val) ? { data: val } : { ...val };

        return (
          <SwiperSlide key={index}>
            <SlideComponent
              {...slideComponentData}
              {...(sameStyles ? sameStyles : style)}
              {...slideComponentProps}
            />
          </SwiperSlide>
        );
      })}
    </Swiper>
  </Box>
);

export default memo(Slider);
